import { gql } from "@apollo/client";

const Fragments = {
  userProfile: gql`
    fragment userProfile on UserProfile {
      userId
      email
      picture
      firstName
      lastName
      positionName
      phone
      mobilePhone
      address1
      address2
      cityName
      zipCode
      stateName
      maxSizeInKB
      allowedFileExtensions
    }
  `,
};

export default Fragments;
